import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Grid, Typography, Button } from '@material-ui/core';
import { push } from 'connected-react-router';

import { MiUiTheme } from 'Console/utils/styleUtils';
import { ACCOUNT_DETAIL_ROUTE } from 'Console/constants/routes';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        alignItems: 'center',
        padding: '0 24px',
        fontSize: theme.typography.pxToRem(14),
    },
    title: {
        display: 'inline-block',
        fontWeight: 'bold',
        paddingBottom: theme.typography.pxToRem(35),
    },
    message: {
        fontSize: theme.typography.pxToRem(14),
        marginBottom: theme.typography.pxToRem(25),
    },
    itemBox: {
        paddingBottom: theme.typography.pxToRem(25),
    },
    subscriptionItem: {
        width: '20%',
        paddingRight: '3%',
    },
    subscriptionValue: {
        width: '25%',
        paddingRight: '3%',
    },
});

class Billing extends Component {
    // @TODO change email and subject
    openMail = () => {
        const mailWindow = 'mailto:info@yeself.com?Subject=change%20subcription%20plan';
        window.open(mailWindow, '_blank');
    };

    render() {
        const { classes, intl, push } = this.props;
        return (
            <Grid container className={classes.root}>
                <Grid container alignItems="center" className={classes.itemBox}>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" className={classes.title}>
                            {intl.formatMessage({ id: 'Accounts.settings.billing.subscription' })}
                        </Typography>
                    </Grid>

                    <Grid container alignItems="center" className={classes.itemBox}>
                        <Grid item className={classes.subscriptionItem}>
                            <Typography variant="body1">
                                {intl.formatMessage({ id: 'Accounts.settings.billing.currentPlan' })}
                            </Typography>
                        </Grid>

                        <Grid item className={classes.subscriptionValue}>
                            <Typography variant="body1">Adopt Medium Cloud</Typography>
                        </Grid>

                        <Grid item>
                            <Typography>
                                <Button
                                    id="yeself-button"
                                    variant="outlined"
                                    color="primary"
                                    onClick={this.openMail}
                                >
                                    {intl.formatMessage({ id: 'Buttons.requestAChange' })}
                                </Button>
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container alignItems="center" className={classes.itemBox}>
                        <Grid item className={classes.subscriptionItem}>
                            <Typography variant="body1">
                                {intl.formatMessage({ id: 'Accounts.settings.billing.currentUsage' })}
                            </Typography>
                        </Grid>

                        <Grid item className={classes.subscriptionValue}>
                            <Typography variant="body1">2/100</Typography>
                        </Grid>

                        <Grid item className={classes.subscriptionValue}>
                            <Typography variant="body1">
                                {intl.formatMessage({ id: 'Accounts.settings.billing.activeUsers' })}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container alignItems="center" className={classes.itemBox}>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" className={classes.title}>
                            {intl.formatMessage({ id: 'Accounts.settings.billing.billingDetails' })}
                        </Typography>
                    </Grid>

                    <Grid container alignItems="center" className={classes.itemBox}>
                        <Grid item className={classes.subscriptionItem}>
                            <Typography variant="body1">
                                {intl.formatMessage({ id: 'Accounts.settings.billing.paymentMethod' })}
                            </Typography>
                        </Grid>

                        <Grid item className={classes.subscriptionValue}>
                            <Typography variant="body1">MasterCard****6397 (05/21)</Typography>
                        </Grid>

                        <Grid item>
                            <Typography>
                                <Button
                                    id="yeself-button"
                                    variant="outlined"
                                    color="primary"
                                    onClick={() =>
                                        push(
                                            `${ACCOUNT_DETAIL_ROUTE}268e574e-fbb6-44c3-83b6-e8b89dd29916/settings/billing-update`
                                        )
                                    }
                                >
                                    {intl.formatMessage({ id: 'Buttons.update' })}
                                </Button>
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container alignItems="center" className={classes.itemBox}>
                        <Grid item className={classes.subscriptionItem}>
                            <Typography variant="body1">
                                {intl.formatMessage({ id: 'Accounts.settings.billing.nextBillingDate' })}
                            </Typography>
                        </Grid>

                        <Grid item className={classes.subscriptionValue}>
                            <Typography variant="body1">12. april 2020</Typography>
                        </Grid>
                    </Grid>

                    <Grid container alignItems="center" className={classes.itemBox}>
                        <Grid item className={classes.subscriptionItem}>
                            <Typography variant="body1">
                                {intl.formatMessage({ id: 'Accounts.settings.billing.billingCountry' })}
                            </Typography>
                        </Grid>

                        <Grid item className={classes.subscriptionValue}>
                            <Typography variant="body1">Slovakia</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container alignItems="center" className={classes.itemBox}>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" className={classes.title}>
                            {intl.formatMessage({ id: 'Accounts.settings.billing.cancelSubscription' })}
                        </Typography>
                    </Grid>

                    <Grid container alignItems="center" className={classes.itemBox}>
                        <Grid item className={classes.subscriptionItem} style={{ width: '45%' }}>
                            <Typography variant="body1">
                                {intl.formatMessage({
                                    id: 'Accounts.settings.billing.cancelSubscription.message',
                                })}
                            </Typography>
                        </Grid>

                        <Grid item>
                            <Typography>
                                <Button
                                    id="yeself-button"
                                    variant="outlined"
                                    style={{
                                        color: MiUiTheme.palette.tertiary.main,
                                        borderColor: MiUiTheme.palette.tertiary.main,
                                    }}
                                    onClick={this.openMail}
                                >
                                    {intl.formatMessage({ id: 'Buttons.cancel.subscription' })}
                                </Button>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default connect(null, { push })(withStyles(styles)(injectIntl(Billing)));
